<script lang="ts">
	export let bindingVal: boolean;
	export let title: string;
</script>

<div class="flex gap-2">
	<div class="text-fx-grey-200">{title}</div>
	<div
		class="border border-fx-grey-500 rounded-md bg-fx-grey-800 w-6 h-6 cursor-pointer flex items-center justify-center"
	>
		<input
			bind:checked={bindingVal}
			type="checkbox"
			class="checked:bg-fx-gradient-13 appearance-none w-3 h-3 rounded-sm cursor-pointer"
		/>
	</div>
</div>
